module.exports = __webpack_public_path__ + "img/icon_4_14.59051652.png";